import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LabItemView from "@/modern/components/training/learningPaths/item/LabItemView.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null,
    machine_id: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LabItemView, {
    kind: "machine",
    "pathway-id": __props.id,
    "resource-id": __props.machine_id
  }, null, 8, ["pathway-id", "resource-id"]))
}
}

})